import React from 'react';
import loader from "../assets/images/tiger2.png"

const GifLoder = () => {
    return (
        <>
            <img src={loader} alt="gif" className="loderDivimg" />
        </>
        );
    };
export default GifLoder;